import styled from 'styled-components';

export const Question = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 120px;
  height: auto;
  border-radius: 6px;
  padding: 20px 25px;
  background: ${(props) =>
    !props.image ? (props.background ? props.background : '#333') : `url(${props.image})`};
  background-position: center;
  background-size: cover;

  p {
    color: ${(props) => props.textColor};
    text-align: center;
    font-size: 24px;
    font-family: Roboto;
    line-height: 1.5;
    margin: 0;
    width: 100%;
    height: fit-content;
    border: 0;
    resize: none;
    background: none;
    word-break: break-word;
  }
`;

export const TextImage = styled.div`
  color: ${(props) => props.textColor};
  width: 100%;
  min-height: 40px;
  height: auto;
  font-size: 20px;
  text-align: center;
  background: #f7f7f7;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-top: 1px;
  padding: 20px 25px;

  p {
    color: ${(props) => props.textColor};
    text-align: center;
    font-size: 24px;
    font-family: Roboto;
    line-height: 1.5;
    margin: 0;
    width: 100%;
    height: fit-content;
    border: 0;
    resize: none;
    background: none;
    word-break: break-word;
  }
`;
